module.exports = __webpack_public_path__ + "img/pr-5.504ba634.png";